import React, {Fragment} from 'react';
import { Radio } from 'material-ui';
import {Props} from '../Builder/ElementProperties';

const MultipleChoiceElement = (props) => {

	return (
		<div style={{whiteSpace:'pre-wrap'}}>
			<div style={{color:'black', marginBottom:'20px'}}>{props.element.text}</div>
			<div>
				{props.element.options.map( (option, index) => 
					<div key={option + index} onClick={ () => { 
							
							props.element.value = option;
							props.experiment.recordEvent({eventType:'User Action', actionType:'click', screenId:props.experiment.currentScreen.id, elementId:props.element.id, elementType:'multiplechoice', value: option, expectedValue: props.element.expected });
							Props.onClickHandler({props});

						}} className={`MultipleChoiceElement-option ${props.element.value === option ? 'selected' : ''}`}>
						<Radio checked={props.element.value === option} color="primary" />
						<span style={{position:'relative', top:'1px'}}>{option}</span>
					</div>
				)}
			</div>
		</div>
	);
}

const Properties = (props) => (
	<Fragment>
		<Props.Id {...props} />
		<Props.X {...props} />
		<Props.Y {...props} />
		<Props.Width {...props} />
		<Props.Height {...props} />
		<Props.Text {...props} />
		<Props.Options {...props} />
		<Props.Expected {...props} />
		<Props.OnClick {...props} />
	</Fragment>
);

MultipleChoiceElement.type = 'multiplechoice';
MultipleChoiceElement.Properties = Properties;
MultipleChoiceElement.defaultJSON = {type: 'multiplechoice', id:'New Multiple Choice', x: 10, y:10, width:480, height:300, text:'Multiple Choice:', value:-1, 
options:['Strongly Disagree', 'Disagree', 'Neutral', 'Agree', 'Strongly agree'], expected: '', onClick:''};
export default MultipleChoiceElement;


// WEBPACK FOOTER //
// ./src/components/ScreenElements/MultipleChoiceElement.js